import GenericErrorTurnback from './GenericErrorTurnback'
const Error404 = () => {
  return (
    <GenericErrorTurnback
      mangoButtonLink={{
        href: 'https://help.humanforce.com/hc/en-au/articles/360029504211-Welcome-to-the-Humanforce-Help-Portal',
        key: 'help-centre-button',
        target: '_blank',
        testId: 'help-centre-button',
        text: 'Help Centre',
        variant: 'tertiary',
      }}
      mangoButton={{
        buttonText: 'Back to Home',
        href: '/',
        key: 'refresh-button',
        testId: 'refresh-button',
        variant: 'primary',
      }}
      mangoTurnBack={{
        description: `If you think that this page should exist, first check that you've typed the correct URL, then contact your
            system administrator`,
        testId: 'page-not-found',
        title: "This page doesn't exist",
        variant: 'page-not-found',
      }}
    />
  )
}

export default Error404
